import { type ComputedRef, computed } from 'vue'

import { useShoppingAssistantFab } from '../stores/useShoppingAssistantFab'
import { useShoppingAssistantWebSidebar } from '../stores/useShoppingAssistantWebSidebar'

import { useIsShoppingAssistantWebEnabled } from './useIsShoppingAssistantWebEnabled'

/**
 * Whether the shopping-assistant FAB is actually on screen right now: the
 * feature is enabled for this route/market, the assistant isn't open, and the
 * manual FAB visibility toggle hasn't been turned off. The FAB hides itself
 * (`v-show`) while its own panel/overlay is open, see
 * WebSidebarShoppingAssistantFAB.vue. Consumed cross-scope by unrelated
 * bottom-right popups that need to clear the FAB's footprint (see
 * useShoppingAssistantPopupOffset).
 */
export function useIsShoppingAssistantFabVisible(): ComputedRef<boolean> {
  const isEnabled = useIsShoppingAssistantWebEnabled()
  const sidebarStore = useShoppingAssistantWebSidebar()
  const fabStore = useShoppingAssistantFab()

  return computed(
    () => isEnabled.value && !sidebarStore.isOpen && fabStore.isVisible,
  )
}
